import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '@/contexts/Auth0Context'
import { UserRole } from '@/types/user'

interface ProtectedRouteProps {
  children: React.ReactNode
  allowedRoles?: UserRole[]
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, allowedRoles }) => {
  const { isAuthenticated, user } = useAuth()

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  if (allowedRoles && user && !allowedRoles.includes(user.role)) {
    // Redirect to appropriate dashboard if user doesn't have required role
    const dashboardRoute = getDashboardRouteForRole(user.role)
    return <Navigate to={dashboardRoute} replace />
  }

  return <>{children}</>
}

const getDashboardRouteForRole = (role: UserRole): string => {
  switch (role) {
    case UserRole.ADMIN:
      return '/admin'
    case UserRole.MENTOR:
      return '/mentor/dashboard'
    default:
      return '/mentee/dashboard'
  }
}

export default ProtectedRoute